// Profiles
export const PROFILE_BIO_MAX = 500
export const PROFILE_DISPLAY_NAME_MAX = 100
export const PROFILE_CONTEXT_MAX = 1500
export const PROFILE_USERNAME_MIN = 3
export const PROFILE_USERNAME_MAX = 25

// Workspaces
export const WORKSPACE_NAME_MAX = 100
export const WORKSPACE_DESCRIPTION_MAX = 500
export const WORKSPACE_INSTRUCTIONS_MAX = 1500

// Chats

// Presets
export const PRESET_NAME_MAX = 100
export const PRESET_DESCRIPTION_MAX = 500
export const PRESET_PROMPT_MAX = 100000

// Prompts
export const PROMPT_NAME_MAX = 100
export const PROMPT_CONTENT_MAX = 100000

// Files
export const FILE_NAME_MAX = 100
export const FILE_DESCRIPTION_MAX = 500

// Collections
export const COLLECTION_NAME_MAX = 100
export const COLLECTION_DESCRIPTION_MAX = 500

// Assistant
export const ASSISTANT_NAME_MAX = 100
export const ASSISTANT_DESCRIPTION_MAX = 500
export const ASSISTANT_PROMPT_MAX = 100000

// Tools
export const TOOL_NAME_MAX = 100
export const TOOL_DESCRIPTION_MAX = 500

// Models
export const MODEL_NAME_MAX = 100
export const MODEL_DESCRIPTION_MAX = 500

// Spaces notes
// Kept under Claude's ~200k context window: notes are vectorized like files
// so only retrieved chunks enter the prompt, not the full body.
export const SPACE_NOTE_CONTENT_MAX = 150000
